/**
 * Type d'entité affiché sur une carte de conflit (clés i18n
 * `canvas:merge.entityKind.*`), d'après la classe ODA lue dans l'instantané
 * (nom DXF : AcDbLine, AcDbMText…).
 */

export type EntityKindLabel =
  | "line"
  | "polyline"
  | "arc"
  | "circle"
  | "ellipse"
  | "text"
  | "block"
  | "leader"
  | "hatch"
  | "dimension"
  | "table"
  | "entity";

const BY_CLASS: Record<string, EntityKindLabel> = {
  AcDbLine: "line",
  AcDbPolyline: "polyline",
  AcDb2dPolyline: "polyline",
  AcDb3dPolyline: "polyline",
  AcDbSpline: "polyline",
  AcDbArc: "arc",
  AcDbCircle: "circle",
  AcDbEllipse: "ellipse",
  AcDbText: "text",
  AcDbMText: "text",
  AcDbBlockReference: "block",
  AcDbMLeader: "leader",
  AcDbLeader: "leader",
  AcDbHatch: "hatch",
  AcDbTable: "table",
};

export function entityKindLabel(className: string): EntityKindLabel {
  if (BY_CLASS[className]) return BY_CLASS[className];
  if (className.endsWith("Dimension")) return "dimension";
  return "entity";
}
